module.exports = __webpack_public_path__ + "static/media/white-car.b9d9fa86.svg";